// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews--reviews--4949bf","loader":"Reviews--loader--2d63bd","empty":"Reviews--empty--9e87aa"};